import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import route from '../../utils/Routes';
import { useAuthContext } from '../../context/AuthContext';
import constants from '../../utils/Constants';

function HomePage() {
    const { ctxtUser, setLoadingScreen } = useAuthContext();
    const navigate = useNavigate();
    useEffect(() => {
        console.log("call use effect ---------------------111");
        setLoadingScreen(true);
        if (ctxtUser?.token) {
          if (ctxtUser?.isComUser === true)
            navigate(route.comPoTrackingList, { replace: true });
          else if (ctxtUser?.isComUser === false)
            navigate(route.comList, { replace: true });
        }
        else
          navigate(route.login, { replace: true });
        setLoadingScreen(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

    return (<div>HomePage</div>)
}

export default HomePage

